(function(){
  // Variant switching
  var pills = document.querySelectorAll('.pdp-pill');
  var sel = document.querySelector('.pdp-variant-select');
  var addBtn = document.querySelector('.pdp-cta');
  var priceNow = document.querySelector('.pdp-price-now');
  var stuckPrice = document.querySelector('.pdp-stuck-price');
  var stuckCta = document.querySelector('.pdp-stuck-cta');
  var variants = window.__onaPdpVariants || [];

  function curOptions(){
    var arr = [];
    document.querySelectorAll('.pdp-pills').forEach(function(g){
      var act = g.querySelector('.pdp-pill.is-active');
      arr.push(act ? act.getAttribute('data-value') : null);
    });
    return arr;
  }
  function syncSelected(){
    document.querySelectorAll('.pdp-option').forEach(function(g){
      var lbl = g.querySelector('.pdp-option-label .selected');
      var act = g.querySelector('.pdp-pill.is-active');
      if (lbl && act) lbl.textContent = act.getAttribute('data-value');
    });
  }
  function syncVariant(){
    if (!variants.length) return;
    var sel_opts = curOptions();
    var match = variants.find(function(v){ return v.options.every(function(o,i){return o === sel_opts[i]}); });
    if (!match) return;
    if (sel) sel.value = match.id;
    if (priceNow) priceNow.textContent = match.price_formatted;
    if (stuckPrice) stuckPrice.textContent = match.price_formatted;
    [addBtn, stuckCta].forEach(function(b){
      if (!b) return;
      if (match.available){
        b.disabled = false;
        b.querySelector('.pdp-cta-label, .pdp-stuck-cta-label, span:first-child') && (b.querySelector('.pdp-cta-label, .pdp-stuck-cta-label, span:first-child').textContent = 'Ajouter au panier');
      } else {
        b.disabled = true;
        b.querySelector('.pdp-cta-label, .pdp-stuck-cta-label, span:first-child') && (b.querySelector('.pdp-cta-label, .pdp-stuck-cta-label, span:first-child').textContent = 'Épuisé');
      }
    });
  }
  pills.forEach(function(p){
    p.addEventListener('click', function(){
      if (p.getAttribute('data-soldout') === 'true') return;
      var grp = p.closest('.pdp-pills');
      grp.querySelectorAll('.pdp-pill').forEach(function(x){x.classList.remove('is-active')});
      p.classList.add('is-active');
      syncSelected(); syncVariant();
    });
  });
  syncSelected();

  // Sticky add-to-cart
  var stuck = document.querySelector('.pdp-stuck');
  var mainCta = document.querySelector('.pdp-cta');
  if (stuck && mainCta && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        stuck.classList.toggle('is-visible', !e.isIntersecting);
      });
    }, {threshold:0, rootMargin:'-100px 0px 0px 0px'});
    obs.observe(mainCta);
  }
  if (stuckCta && mainCta) {
    stuckCta.addEventListener('click', function(){ mainCta.click(); });
  }

  // Thumbnail navigation
  var mainImg = document.querySelector('#pdpMainImg img');
  document.querySelectorAll('.pdp-thumb').forEach(function(t){
    t.addEventListener('click', function(){
      var src = t.getAttribute('data-full');
      if (!src || !mainImg) return;
      document.querySelectorAll('.pdp-thumb').forEach(function(x){x.classList.remove('is-active')});
      t.classList.add('is-active');
      mainImg.style.opacity = '0';
      setTimeout(function(){ mainImg.src = src; mainImg.style.opacity = '1'; }, 180);
    });
  });


  // Color swatches
  document.querySelectorAll('.pdp-swatch').forEach(function(s){
    s.addEventListener('click', function(){
      if (s.getAttribute('data-soldout') === 'true') return;
      var grp = s.closest('.pdp-pills');
      grp.querySelectorAll('.pdp-swatch').forEach(function(x){x.classList.remove('is-active')});
      s.classList.add('is-active');
      var optBox = s.closest('.pdp-option');
      var lbl = optBox.querySelector('.pdp-option-label .selected');
      if (lbl) lbl.textContent = s.getAttribute('data-value');
      syncSelected(); syncVariant();
      var fullSrc = s.getAttribute('data-full');
      var mainImg = document.querySelector('#pdpMainImg img');
      if (fullSrc && mainImg) {
        mainImg.style.opacity = '0';
        setTimeout(function(){ mainImg.src = fullSrc; mainImg.style.opacity = '1'; }, 180);
      }
    });
  });


  // Buy Now handler — add to cart then go to /checkout
  document.querySelectorAll('[data-buy-now]').forEach(function(b){
    b.addEventListener('click', function(e){
      e.preventDefault();
      if (b.disabled) return;
      var form = b.closest('form');
      if (!form) return;
      var fd = new FormData(form);
      var btnLabel = b.querySelector('.pdp-cta-label');
      var orig = btnLabel ? btnLabel.textContent : 'Acheter';
      if (btnLabel) btnLabel.textContent = 'En cours…';
      b.disabled = true;
      fetch('/cart/add.js', {method:'POST', body:fd, headers:{'Accept':'application/json'}})
        .then(function(r){ return r.json(); })
        .then(function(){ window.location.href = '/checkout'; })
        .catch(function(){
          if (btnLabel) btnLabel.textContent = orig;
          b.disabled = false;
        });
    });
  });

})();